import { Root, MuiThemeProvider } from './providers';
import { AuthProvider, AuthConsumer, LoadingProvider, SettingsProvider } from 'contexts';
  
import App from './App';
import { SnackbarProvider } from 'components/snackbar';
import ContextLoader from 'components/ContextLoader';
import { LocalizationProvider } from 'locales';
import { HelmetProvider } from 'react-helmet-async';

Root.render(
  <HelmetProvider>
    <AuthProvider>
      <LocalizationProvider>
        <LoadingProvider>
          <SettingsProvider
            defaultSettings={{
              lang: 'en',
              themeMode: 'light', // 'light' | 'dark'
              themeDirection: 'ltr', //  'rtl' | 'ltr'
            }}
          >
            <MuiThemeProvider>
              <AuthConsumer>
                <SnackbarProvider>
                  <ContextLoader />
                  <App />
                </SnackbarProvider>
              </AuthConsumer>
            </MuiThemeProvider>
          </SettingsProvider>
        </LoadingProvider>
      </LocalizationProvider>
    </AuthProvider>
  </HelmetProvider>
);
